import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Container, Row, Col, Card, Dropdown } from 'react-bootstrap';
import GlobalIpModal from './GlobalIpModal';

const Home = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('Administrator');
  const [menus, setMenus] = useState([]);
  const [activeMenu, setActiveMenu] = useState('');
  const [hoveredInfo, setHoveredInfo] = useState(null);
  const [time, setTime] = useState({ date: '', clock: '' });
  const [allSubMenus, setAllSubMenus] = useState([]);
  const [showGlobalIpModal, setShowGlobalIpModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const location = useLocation();

  useEffect(() => {
    const savedUser = localStorage.getItem('nama_user') || localStorage.getItem('user');
    if (savedUser) setUsername(savedUser);

    const savedMenu = localStorage.getItem('mainmenu');
    if (savedMenu) {
      const parsedMenu = JSON.parse(savedMenu);
      setMenus(parsedMenu);
    }

    const savedSubMenu = localStorage.getItem('submenu');
    if (savedSubMenu) {
      setAllSubMenus(JSON.parse(savedSubMenu));
    }

    const updateTime = () => {
      const now = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      setTime({
        date: now.toLocaleDateString('id-ID', options),
        clock: now.toLocaleTimeString('id-ID') + ' WIB'
      });
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const getBoxStyle = (index) => {
    const boxStyles = [styles.box1, styles.box2, styles.box3, styles.box4];
    return boxStyles[index % boxStyles.length];
  };

  const getSubMenuIcon = (name) => {
    if (!name) return 'bi-card-list';
    const n = name.toUpperCase();
    if (n.includes('MASTER') || n.includes('BARANG') || n.includes('OBAT')) return 'bi-folder2-open';
    if (n.includes('GUDANG') || n.includes('STOK') || n.includes('TTB') || n.includes('TANDA TERIMA')) return 'bi-box-seam';
    if (n.includes('USER') || n.includes('PENGGUNA') || n.includes('AKUN')) return 'bi-people-fill';
    if (n.includes('SETTING') || n.includes('PENGATURAN') || n.includes('KONFIGURASI')) return 'bi-sliders';
    if (n.includes('LAPORAN') || n.includes('REPORT')) return 'bi-file-earmark-bar-graph';
    if (n.includes('KEUANGAN') || n.includes('FAKTUR') || n.includes('INVOICE')) return 'bi-wallet2';
    return 'bi-journal-bookmark-fill';
  };

  const getMenuIcon = (menuName) => {
    switch (menuName.toUpperCase()) {
      case 'MASTER':        return 'bi-folder2-open';
      case 'GUDANG':        return 'bi-box-seam';
      case 'ADM GUDANG':    return 'bi-building-gear';
      case 'APOTEKER':      return 'bi-prescription2';
      case 'ADMINISTRATOR': return 'bi-person-workspace';
      case 'SETTING':       return 'bi-sliders';
      default:              return 'bi-grid-1x2';
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <div style={styles.appContainer}>
      {/* ══════════════ 1. TOP NAVBAR ══════════════ */}
      <nav className="navbar navbar-expand-xl navbar-dark shadow-sm" style={styles.navbarCustom}>
        <Container fluid>
          <a
            className="navbar-brand d-flex align-items-center me-3"
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              setActiveMenu('');
            }}
            style={{ cursor: 'pointer', textDecoration: 'none' }}
          >
            <div className="d-flex align-items-center justify-content-center me-2 rounded-3 p-1.5"
              style={{ background: 'rgba(255, 255, 255, 0.1)', border: '1px solid rgba(255, 255, 255, 0.15)' }}>
              <i className="bi bi-layers-half text-warning fs-5"></i>
            </div>
            <div>
              <div className="fw-bold text-white lh-1" style={{ fontSize: '0.95rem', letterSpacing: '0.3px' }}>
                SILK <span style={{ color: '#2dd4bf', fontWeight: 500, fontSize: '0.8rem' }}>Healthcare ERP</span>
              </div>
              <div className="text-white-50 small" style={{ fontSize: '0.65rem' }}>Solusi Integrasi Layanan Kesehatan</div>
            </div>
          </a>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 flex-row gap-1">
              {menus.map((item) => {
                const isActive = activeMenu === item.id_mn;

                return (
                  <li className="nav-item" key={item.id_mn}>
                    <a
                      className={`nav-link-custom ${isActive ? 'active' : ''}`}
                      href={`#${item.des_mn.toLowerCase().replace(/\s+/g, '-')}`}
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveMenu(item.id_mn);
                      }}
                      style={{
                        ...styles.navLinkCustom,
                        ...(isActive ? styles.navLinkActive : {})
                      }}
                    >
                      <i className={`bi ${getMenuIcon(item.des_mn)} me-1`}></i>
                      {item.des_mn.toLowerCase().replace(/\b\w/g, s => s.toUpperCase())}
                    </a>
                  </li>
                );
              })}
            </ul>

            <div className="d-flex align-items-center text-white text-end gap-3 ms-auto">
              <div className="small border-end pe-3 border-light border-opacity-25 d-none d-sm-block">
                <div className="fw-semibold text-white-50" style={{ fontSize: '0.75rem' }}>{time.date}</div>
                <div className="fw-bold" style={{ fontSize: '0.8rem', color: '#5eead4' }}>{time.clock}</div>
              </div>

              <Dropdown align="end">
                <Dropdown.Toggle
                  as="div"
                  role="button"
                  className="d-flex align-items-center gap-2 px-2 py-1 rounded-3 custom-profile-toggle"
                  style={{ cursor: 'pointer', transition: 'all 0.2s ease', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)' }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center fw-bold rounded-circle shadow-sm"
                    style={{ width: '34px', height: '34px', fontSize: '0.85rem', background: 'linear-gradient(135deg, #f59e0b, #d97706)', color: '#ffffff' }}
                  >
                    {username ? username.charAt(0).toUpperCase() : 'A'}
                  </div>

                  <div className="d-none d-md-block text-start">
                    <div className="text-white fw-semibold lh-1" style={{ fontSize: '0.82rem' }}>{username}</div>
                    <div className="mt-1 d-flex align-items-center gap-1" style={{ fontSize: '0.68rem', color: '#5eead4' }}>
                      <span className="rounded-circle bg-success d-inline-block" style={{ width: '6px', height: '6px' }}></span>
                      <span>Online</span>
                    </div>
                  </div>
                  <i className="bi bi-chevron-down text-white-50 ms-1 small"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu className="shadow-lg border-0 mt-2 py-2 style-dropdown-menu" style={{ minWidth: '200px', borderRadius: '12px' }}>
                  <div className="px-3 py-2 border-bottom mb-1 bg-light rounded-top">
                    <p className="text-muted small mb-0" style={{ fontSize: '0.7rem' }}>Pengguna Aktif</p>
                    <p className="fw-bold text-dark mb-0" style={{ fontSize: '0.85rem' }}>{username}</p>
                  </div>

                  <Dropdown.Item onClick={() => setShowGlobalIpModal(true)} className="py-2 text-dark small d-flex align-items-center gap-2 fw-semibold">
                    <i className="bi bi-hdd-network-fill text-warning fs-6"></i> Pengaturan IP Server
                  </Dropdown.Item>

                  <Dropdown.Item onClick={handleLogout} className="py-2 text-danger small d-flex align-items-center gap-2 fw-semibold">
                    <i className="bi bi-box-arrow-right fs-6"></i> Keluar Aplikasi
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Container>

        <GlobalIpModal
          show={showGlobalIpModal}
          onHide={() => setShowGlobalIpModal(false)}
        />
      </nav>

      {/* ══════════════ 2. MAIN CONTENT AREA ══════════════ */}
      <div style={styles.mainContent}>
        {!activeMenu ? (
          /* TAMPILAN LANDING PAGE PERTAMA KALI LOGIN (SOFTER LIGHT GLASSMORPHISM OVERLAY) */
          <div className="flex-grow-1 d-flex flex-column justify-content-center overflow-hidden mb-2" style={{ minHeight: 0 }}>
            <div
              className="card border-0 shadow-lg w-100 h-100 d-flex flex-column justify-content-between p-0"
              style={{
                borderRadius: '16px',
                position: 'relative',
                minHeight: 0,
                overflow: 'hidden',
                border: '1px solid #cbd5e1',
                background: '#f8fafc',
              }}
            >
              {/* Header Badge Overlay (Softer Translucent Gradient) */}
              <div className="position-absolute top-0 start-0 w-100 p-2.5 d-flex align-items-center justify-content-between"
                style={{ zIndex: 5, background: 'linear-gradient(180deg, rgba(15, 23, 42, 0.4) 0%, rgba(15, 23, 42, 0) 100%)' }}>
                <div className="d-flex align-items-center gap-2 px-2">
                  <span className="badge rounded-pill px-3 py-1.5 fw-medium shadow-sm"
                    style={{ background: 'linear-gradient(135deg, #0d9488, #0f766e)', color: '#fff', fontSize: '0.73rem', border: '1px solid rgba(255,255,255,0.3)' }}>
                    <i className="bi bi-stars me-1 text-warning"></i> Selamat Datang, {username}
                  </span>
                  <span className="text-white d-none d-md-inline fw-medium" style={{ fontSize: '0.73rem', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                    Sistem ERP Rantai Pasok Farmasi & Layanan Kesehatan Terpadu
                  </span>
                </div>
              </div>

              {/* Background Image Container (FULL EDGE-TO-EDGE) */}
              <div className="w-100 h-100 flex-grow-1 position-relative overflow-hidden" style={{ minHeight: 0 }}>
                <img
                  src="/welcome_bg.png"
                  alt="SOLUSI INTEGRASI LAYANAN KESEHATAN"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'fill',
                    objectPosition: 'center',
                    imageRendering: 'high-quality',
                    display: 'block',
                  }}
                />
              </div>

              {/* Floating Action Hint Overlay di Bawah (Soft White Glassmorphism) */}
              <div className="position-absolute bottom-0 start-0 w-100 p-2.5 d-flex align-items-center justify-content-center"
                style={{ zIndex: 5, background: 'linear-gradient(0deg, rgba(15, 23, 42, 0.35) 0%, rgba(15, 23, 42, 0) 100%)' }}>
                <div
                  className="px-3.5 py-1.5 rounded-pill shadow-lg d-flex align-items-center gap-2 flex-wrap justify-content-center"
                  style={{
                    background: 'rgba(255, 255, 255, 0.92)',
                    backdropFilter: 'blur(16px)',
                    color: '#0f172a',
                    fontSize: '0.78rem',
                    fontWeight: '600',
                    border: '1px solid rgba(255, 255, 255, 0.8)',
                    boxShadow: '0 8px 32px rgba(15, 23, 42, 0.12)',
                  }}
                >
                  <i className="bi bi-hand-index-thumb-fill text-teal fs-6"></i>
                  <span>Silakan pilih <strong>Menu Utama</strong> di atas atau klik:</span>

                  <div className="d-flex align-items-center gap-1 ms-md-1 flex-wrap">
                    {menus.map((m) => (
                      <button
                        key={m.id_mn}
                        onClick={() => setActiveMenu(m.id_mn)}
                        className="btn btn-sm px-2.5 py-0.5 rounded-pill fw-semibold border-0 text-white"
                        style={{
                          background: '#0f172a',
                          fontSize: '0.7rem',
                          transition: 'all 0.2s ease',
                          cursor: 'pointer'
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = '#0d9488'}
                        onMouseLeave={e => e.currentTarget.style.background = '#0f172a'}
                      >
                        <i className={`bi ${getMenuIcon(m.des_mn)} me-1`}></i>
                        {m.des_mn}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          /* TAMPILAN SUB-MENU (TETAP DI ATAS & UKURAN CARD PROPOSIONAL KONSISTEN) */
          <div className="w-100 mb-auto">
            <Row className="g-3 align-items-start mb-3">
              <Col xl={8} lg={7} md={12}>
                <Card style={styles.mainCard} className="shadow-sm border-0">
                  <div style={{ ...styles.cardHeader, ...styles.bgMenuHeader }} className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-2">
                      <i className="bi bi-grid-fill text-warning"></i>
                      <span>SUB MENU — {menus.find(m => m.id_mn === activeMenu)?.des_mn || 'MENU'}</span>
                    </div>
                    <span className="badge rounded-pill bg-light text-dark fw-semibold px-2.5 py-1" style={{ fontSize: '0.7rem' }}>
                      {allSubMenus.filter(sub => sub.id_mn === activeMenu).length} Fitur
                    </span>
                  </div>

                  <Card.Body style={styles.cardBody}>
                    <Row className="row-cols-1 row-cols-sm-2 row-cols-md-4 g-2.5">
                      {allSubMenus
                        .filter((sub) => sub.id_mn === activeMenu)
                        .map((sub, index) => {
                          const menuLabel = sub.des_mn || sub.nama || sub.nm_mm || 'Menu';
                          const menuInfo  = sub.info || '';
                          const menuLnk   = sub.lnk ? sub.lnk.trim() : '#';

                          return (
                            <Col key={sub.id_mm || sub.id_mn + '_' + index}>
                              <Link
                                to={menuLnk}
                                state={{ info: menuInfo, nama: menuLabel }}
                                style={{ ...styles.btnGradientBox, ...getBoxStyle(index) }}
                                onMouseEnter={() => setHoveredInfo({ nama: menuLabel, info: menuInfo })}
                                onMouseLeave={() => setHoveredInfo(null)}
                              >
                                <i className={`bi ${getSubMenuIcon(menuLabel)}`}
                                  style={{ fontSize: '1.6rem', marginBottom: '0.35rem' }}>
                                </i>
                                <span style={{ fontWeight: 700, fontSize: '0.83rem', lineHeight: 1.3 }}>
                                  {menuLabel.toLowerCase().replace(/\b\w/g, s => s.toUpperCase())}
                                </span>
                              </Link>
                            </Col>
                          );
                        })}

                      {allSubMenus.filter((sub) => sub.id_mn === activeMenu).length === 0 && (
                        <Col xs={12} className="text-center text-muted my-3 small py-4">
                          <i className="bi bi-folder-x fs-3 d-block mb-1 opacity-50"></i>
                          Tidak ada sub-menu untuk kategori menu ini.
                        </Col>
                      )}
                    </Row>
                  </Card.Body>
                </Card>
              </Col>

              <Col xl={4} lg={5} md={12}>
                <Card style={styles.mainCard} className="shadow-sm border-0">
                  <div style={{ ...styles.cardHeader, ...styles.bgInfoHeader }}>
                    <i className="bi bi-info-circle-fill me-2 text-warning"></i> Informasi Fitur
                  </div>
                  <Card.Body style={{ ...styles.cardBody, padding: '0.85rem' }}>
                    {hoveredInfo ? (
                      <div style={{
                        background: 'linear-gradient(135deg, #f0fdf4, #dcfce7)',
                        border: '1px solid #86efac',
                        borderLeft: '4px solid #0d9488',
                        borderRadius: '10px',
                        padding: '0.9rem',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 4px 12px rgba(13, 148, 136, 0.08)'
                      }}>
                        <div className="fw-bold mb-1 d-flex align-items-center gap-1.5" style={{ fontSize: '0.84rem', color: '#0f766e' }}>
                          <i className="bi bi-bookmark-fill text-teal"></i>
                          {hoveredInfo.nama}
                        </div>
                        <div style={{ fontSize: '0.78rem', color: '#374151', lineHeight: 1.6 }}>
                          {hoveredInfo.info || <span className="text-muted fst-italic">Tidak ada deskripsi</span>}
                        </div>
                      </div>
                    ) : (
                      <div style={{ maxHeight: '220px', overflowY: 'auto' }}>
                        {allSubMenus
                          .filter(sub => sub.id_mn === activeMenu)
                          .filter(sub => sub.info)
                          .map((sub, i) => (
                            <div key={i} style={{
                              ...styles.infoBox,
                              marginBottom: '0.55rem',
                              padding: '0.65rem 0.85rem',
                            }} className="shadow-sm">
                              <div className="fw-bold mb-1" style={{ fontSize: '0.76rem', color: '#0f766e' }}>
                                <i className="bi bi-chevron-right me-1 text-teal"></i>
                                {sub.des_mn || sub.nama || sub.nm_mm}
                              </div>
                              <div style={{ fontSize: '0.73rem', color: '#475569', lineHeight: 1.5 }}>
                                {sub.info}
                              </div>
                            </div>
                          ))}
                        {allSubMenus
                          .filter(sub => sub.id_mn === activeMenu)
                          .every(sub => !sub.info) && (
                          <div style={styles.infoBox} className="shadow-sm w-100">
                            <i className="bi bi-bell-fill text-warning me-2"></i> Pilih menu yang akan dijalankan
                          </div>
                        )}
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        )}

        {/* ══════════════ FOOTER WIDGETS STATIS (TETAP DI BAWAH) ══════════════ */}
        <Row className="g-3 flex-shrink-0 mt-auto">
          <Col md={4} sm={12}>
            <div style={{ ...styles.summaryCard, ...styles.sum1 }} className="shadow-sm">
              <div>
                <div style={styles.sumValue}>84</div>
                <div style={styles.sumLabel}>Total Pemasok</div>
              </div>
              <div style={styles.iconWrap}><i className="bi bi-people"></i></div>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <div style={{ ...styles.summaryCard, ...styles.sum2 }} className="shadow-sm">
              <div>
                <div style={styles.sumValue}>11</div>
                <div style={styles.sumLabel}>Status Kiriman</div>
              </div>
              <div style={styles.iconWrap}><i className="bi bi-truck"></i></div>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <div style={{ ...styles.summaryCard, ...styles.sum3 }} className="shadow-sm">
              <div>
                <div style={styles.sumValue}>36</div>
                <div style={styles.sumLabel}>Aturan Jual Aktif</div>
              </div>
              <div style={styles.iconWrap}><i className="bi bi-sliders"></i></div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  appContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: '#f8fafc',
    color: '#1e293b',
    overflow: 'hidden',
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.45rem 1.2rem',
    flexShrink: 0,
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 4px 20px rgba(15, 23, 42, 0.15)',
  },
  navLinkCustom: {
    color: 'rgba(226, 232, 240, 0.8)',
    fontSize: '0.78rem',
    fontWeight: '500',
    padding: '0.4rem 0.75rem',
    borderRadius: '8px',
    textDecoration: 'none',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
  },
  navLinkActive: {
    color: '#ffffff',
    background: 'rgba(255, 255, 255, 0.16)',
    backdropFilter: 'blur(8px)',
    fontWeight: '600',
    boxShadow: 'inset 0 1px 1px rgba(255, 255, 255, 0.2)',
  },
  mainContent: {
    flex: 1,
    padding: '0.7rem 0.9rem',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  mainCard: {
    borderRadius: '14px',
    overflow: 'hidden',
    border: '1px solid #e2e8f0',
    background: '#ffffff',
  },
  cardHeader: {
    padding: '0.65rem 1rem',
    color: '#ffffff',
    fontWeight: '600',
    fontSize: '0.83rem',
    letterSpacing: '0.2px',
  },
  bgMenuHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)',
  },
  bgInfoHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0284c7 100%)',
  },
  cardBody: {
    padding: '0.85rem',
    background: '#ffffff',
  },
  btnGradientBox: {
    border: '1px solid rgba(0, 0, 0, 0.04)',
    borderRadius: '12px',
    padding: '0.9rem 0.85rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '110px',
    minHeight: '110px',
    maxHeight: '110px',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '0.8rem',
    textAlign: 'center',
    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.04)',
    gap: '0.15rem',
  },
  box1: { background: 'linear-gradient(135deg, #0d9488 0%, #14b8a6 100%)', color: '#ffffff' },
  box2: { background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)', color: '#0369a1', border: '1px solid #bae6fd' },
  box3: { background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)', color: '#15803d', border: '1px solid #bbf7d0' },
  box4: { background: 'linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)', color: '#b45309', border: '1px solid #fde68a' },
  infoBox: {
    background: 'linear-gradient(90deg, #f8fafc, #f1f5f9)',
    borderLeft: '4px solid #0d9488',
    borderRadius: '8px',
    padding: '0.85rem',
    fontSize: '0.8rem',
    fontWeight: '500',
    color: '#334155',
  },
  summaryCard: {
    border: 'none',
    borderRadius: '14px',
    padding: '0.8rem 1.2rem',
    color: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.06)',
  },
  sum1: { background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)' },
  sum2: { background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)' },
  sum3: { background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)' },
  sumValue: { fontSize: '1.45rem', fontWeight: '700' },
  sumLabel: { fontSize: '0.76rem', opacity: '0.9' },
  iconWrap: { background: 'rgba(255, 255, 255, 0.22)', padding: '6px 10px', borderRadius: '10px', fontSize: '1.15rem' }
};

export default Home;